<template>
  <div>
    <v-layout>
      <v-flex>
        <select-channel v-model="app" @changeChannel="getData"></select-channel>
      </v-flex>
      <v-flex shrink>
        <!-- <v-btn
          v-if="$store.getters.getPackage != 'premium'"
          outline
          v-tooltip.top="'Unlock to PREMIUM plan'"
          color="grey"
          class="ma-0 mb-1"
        >
          <em class="fas fa-file-export mr-1"></em>
          {{ $t('export') }}
          <v-premium-lock></v-premium-lock>
        </v-btn>
        <v-btn
          v-else-if="$store.getters.getPackage == 'premium'"
          @click="exportdata"
          color="primary"
          outline
          class="ma-0 mb-1"
        >
          <em class="fas fa-file-export mr-1"></em>
          {{ $t('export') }}
        </v-btn> -->
        <!-- <v-btn
          fab
          outline
          small
          color="blue"
          :loading="loading"
          v-if="$store.getters.getPackage != 'premium'"
          v-tooltip.top="'Unlock to PREMIUM plan'"
        >
          <v-icon>lock</v-icon>
        </v-btn> -->
        <v-btn fab outline small color="primary" :loading="loading" @click="getData">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 sm12 md6 lg5 class="pa-1">
        <v-card style="border-radius: 5px; height: 100%; position: relative">
          <v-card-title>
            <span>{{ $t('total_users') }}</span>
          </v-card-title>
          <div class="body">
            <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
            <template v-if="totalusersSeries && summary.total_users !== false && !loading">
              <div style="max-width: 220px; margin: auto">
                <apexchart
                  ref="totaluser"
                  type="pie"
                  :options="totalusersOption"
                  :series="totalusersSeries"
                ></apexchart>
              </div>
            </template>
          </div>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md6 lg7>
        <v-layout wrap>
          <v-flex xs12 sm6 md6 lg12 class="pa-1">
            <stat-card v-model="summary.total_users" :loading="loading">{{
              $t('total_users')
            }}</stat-card>
          </v-flex>

          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card v-model="summary.total_male" :loading="loading">
              {{ $t('male') }}
              <span
                style="color: #d4d4d4"
                v-tooltip.top="$t('Number of male users who talked with chatbot (All time)')"
              >
                <em class="fas fa-info-circle"></em>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card v-model="summary.total_female" :loading="loading">
              {{ $t('Female') }}
              <span
                style="color: #d4d4d4"
                v-tooltip.top="$t('Number of female users who talked with chatbot (All time)')"
              >
                <em class="fas fa-info-circle"></em>
              </span>
            </stat-card>
          </v-flex>
          <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
            <stat-card v-model="summary.total_others" :loading="loading">
              {{ $t('no gender') }}
              <span
                style="color: #d4d4d4"
                v-tooltip.top="
                  $t('Number of non-male and non-female users who talked with chatbot (All time)')
                "
              >
                <em class="fas fa-info-circle"></em>
              </span>
            </stat-card>
          </v-flex>

          <v-divider />
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SelectChannel from './SelectChannel'
import StatCard from './StatCard'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from './DashboardGraphLoading'
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      app: 'all',
      summary: {
        total_users: 0,
        canpush: 0,
        total_male: 0,
        total_female: 0,
        total_others: 0
      },
      type: 'onetime',
      totalusersSeries: null,
      loading: true,
      totalusersOption: {
        chart: {
          type: 'pie'
          // height: 350
        },
        labels: [this.$t('male'), this.$t('female'), this.$t('no gender')],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        legend: {
          show: true,
          position: 'bottom'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  components: {
    SelectChannel,
    StatCard,
    apexchart: VueApexCharts,
    DashboardGraphLoading
  },
  async mounted() {
    await this.loadTotalOneTime()
  },
  methods: {
    async loadTotalOneTime() {
      this.loading = true
      try {
        var response = await this.fetchOneTimeData()

        if (response.responsecode == 200 && response.data && response.data.length > 0) {
          this.summary = response.data[0]
          this.totalusersSeries = [
            parseInt(this.summary.total_male),
            parseInt(this.summary.total_female),
            parseInt(this.summary.total_others)
          ]
        } else {
          throw new Error('Not have response')
        }
      } catch (error) {
        this.summary = {
          total_users: false,
          canpush: false,
          total_male: false,
          total_female: false,
          total_others: false
        }

        this.totalusersSeries = null
        this.type = 'recursive'
      }
      this.loading = false
    },
    async loadTotalRecursive(limit, offset) {
      let summary = {
        total_users: 0,
        canpush: 0,
        total_male: 0,
        total_female: 0,
        total_others: 0
      }
      try {
        var response = await this.fetchRecursiveData(limit, offset)

        if (response.responsecode == 200 && response.data && response.data.length > 0) {
          summary = response.data[0]
          //console.log(summary)
          if (summary.is_next) {
            var total = await this.loadTotalRecursive(limit, offset + limit)
            return {
              total_users: parseInt(summary.total_users) + parseInt(total.total_users),
              canpush: parseInt(summary.canpush) + parseInt(total.canpush),
              total_male: parseInt(summary.total_male) + parseInt(total.total_male),
              total_female: parseInt(summary.total_female) + parseInt(total.total_female),
              total_others: parseInt(summary.total_others) + parseInt(total.total_others)
            }
          } else {
            return summary
          }
        } else {
          throw new Error('Not have response')
        }
      } catch (error) {
        // console.log(error)
        return summary
      }
    },
    fetchOneTimeData() {
      var data = {
        params: {},
        body: {
          pageid: this.selectedBot.pageid,
          app: this.app
        }
      }
      return new Promise((resolve, reject) => {
        api.post_total_users(data, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    fetchRecursiveData(limit, offset) {
      var data = {
        params: {
          limit: limit,
          offset: offset
        },
        body: {
          pageid: this.selectedBot.pageid,
          app: this.app
        }
      }

      return new Promise((resolve, reject) => {
        api.post_total_users_calculate(data, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    async getData() {
      if (this.type == 'onetime') {
        await this.loadTotalOneTime()
      } else {
        this.loading = true
        var data = await this.loadTotalRecursive(3000, 0)
        //console.log(data)
        this.summary = data
        this.totalusersSeries = [
          parseInt(data.total_male),
          parseInt(data.total_female),
          parseInt(data.total_others)
        ]
        this.loading = false
      }
    },
    exportdata() {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/TotalUsers.vue